import { get, post } from "../util/activation1.3";
// import { uploadGet, uploadPost } from "../util/uploadPic";
import { uploadPost } from "../util/aggentConfig";
import { getAgentSign, getStamp,getStudySign,getRandom } from '../util/util'

import md5 from "js-md5";

// 1.3修改线索后查询信息接口延迟
export const delay = 500;

// 钉钉-查询用户信息
export const getUserInfoByCode = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/ding/account/getUserInfoByCode",params);
};

// 钉钉-通过AccountId查询用户是否具有业绩管理权限
// 使用方:经销商系统/代理商系统
export const queryUserPowerByUserId = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/dingcockpit/statistics/queryUserPowerByUserId",params);
};

// 钉钉-通过AccountId查询用户是否具有业绩管理权限的campusId
// 使用方:经销商系统/代理商系统
export const queryUserCampusByAccountId = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/dingcockpit/statistics/queryUserCampusByAccountId",params);
};

// 钉钉-通过经销商ID查询员工
// 使用方:经销商系统/代理商系统
export const getPartnersAccountList = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/dingcockpit/statistics/getPartnersAccountList",params);
};

// 钉钉-仪表盘
export const instrumentPanel = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/dingcockpit/statistics/instrumentPanel",params);
};

// 钉钉-查询每日上报列表
export const queryDailyReport = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/dingcockpit/queryDailyReport",params);
};

// 钉钉-查询每日上报详情
export const queryDailyReportById = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/dingcockpit/queryDailyReportById",params);
};

// 钉钉-校验智适应账号
export const checkAccount = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/dingcockpit/checkAccount",params);
};

// 钉钉-校验SN码
export const checkSN = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/dingcockpit/checkSN",params);
};

// 钉钉-新增或修改每日上报
export const saveAndUpdateDailyReport = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/dingcockpit/saveAndUpdateDailyReport",params);
};

// 钉钉-根据sn获取账号
export const queryAccountUserBySn = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/dingcockpit/queryAccountUserBySn",params);
};

// 钉钉-提交订单校验
export const commitOrder   = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/ding/customer/commitOrder",params);
};


export const uploadPicture = (params) => {
  const timestamp = getStamp()
  const rand = getRandom(6);
  const sign = getAgentSign(params)
  return uploadPost(`/base/upload/uploadPicture?time=${timestamp}&rand=${rand}&sign=${sign}`, params)
}

// 钉钉-获取周报消息
export const queryCockpitWeeklyReport   = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/dingcockpit/statistics/queryCockpitWeeklyReport",params);
};
// 钉钉-查询分摊对象
export const queryShareUser   = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/dingcockpit/queryShareUser",params);
};

// 钉钉-管理版-获取员工明细数据
export const listMembershipDetails   = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/dingcockpit/statistics/listMembershipDetails",params);
};
// 钉钉-管理版-获取工作抽查列表
export const listWorkSpotData   = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/dingcockpit/statistics/listWorkSpotData",params);
};

// 钉钉-查询线索
export const queryMultiCampusCustomerInfo = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/ding/customer/queryMultiCampusCustomerInfo", params);
};

// 钉钉-新增修改线索
export const addEditCustomer = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/ding/customer/addEditCustomer", params);
};

// 获取线索详情
export const customArticle = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/ding/customer/customArticle", params);
};
// 获取渠道来源
export const OriginTypelist = (params) => get("/api/ding/customer/channel/list", params);

// 钉钉-跟进线索列表查询
export const listRecord = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/ding/customer/listRecord", params);
};

// 钉钉-新增修改跟进线索
export const addRecord = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/ding/customer/addRecord", params);
};

// 钉钉-潜在客户订单列表
export const queryCustomOrderList = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/ding/customer/queryCustomOrderList", params);
};

// 来源列表
export const querySourceByParentId = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return get("/api/ding/customer/querySourceByParentId", params);
};

// 学校列表
export const queryBaseSchool = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/ding/customer/queryBaseSchool", params);
};

// 标记失效
export const markingFailureForCustom = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/ding/customer/markingFailureForCustom", params);
};

// 修改意向程度
export const updateCustomIntend = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/ding/customer/updateCustomIntend", params);
};

// 字典
export const getDictionaryList = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return get("/api/dictionary/getDictionaryList", params);
};

// 删除潜在客户订单
export const deleteCustomOrder = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/ding/customer/deleteCustomOrder", params);
};

// 删除潜在客户订单
export const getUserList = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/dingcockpit/statistics/workSpot/getUserList", params);
};

// 我的转化
export const queryUserCustomOrderList = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/dingcockpit/queryUserCustomOrderList", params);
};
// 钉钉-通知详情
export const queryDingNoticeDetail = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
return post("/ding/notice/queryDingNoticeDetail",params);
};
// 钉钉-提交异议
export const addDingNoticeObjection = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
return post("/ding/notice/addDingNoticeObjection",params);
};

// 钉钉-业绩管理埋点
export const insertTrackingData = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/potential/insertTrackingData",params);
};
// 坐席登录
export const userSeat = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/manage/callCenter/common/userSeat",params);
};
// 呼入时查询线索信息
export const queryCampusCustomerInfoCallIn = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/ding/customer/queryCampusCustomerInfoCallIn",params);
};
// 校验该经销商是否开通过外呼服务
export const checkCampusIsOpen = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/ding/customer/checkCampusIsOpen",params);
};
// 转交线索
export const changeCustomCrOwner = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/ding/customer/changeCustomCrOwner",params);
};
// 查询员工列表
export const getSubUsers = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/ding/customer/getSubUsers",params);
};
// 在外呼或呼入时，选择性的更新潜在客户的跟进状态以及操作人
export const updCustomFollow = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/manage/callCenter/common/updCustomFollow",params);
};
// 在呼入时，弹窗是否展示需要后端check
export const callInCheck = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/manage/callCenter/common/callInCheck",params);
};
// 钉钉-业绩管理获取员工的通话记录信息（全部&未接通话）
export const getSaleCallRecordsByType = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/manage/callCenter/common/getSaleCallRecordsByType",params);
};
// 接收前端推送的通话事件数据
export const callEventLog = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/manage/callCenter/order/callEventLog",params);
};
// 查询员工的通话记录信息
export const getCampusNormalUsers = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/ding/customer/getCampusNormalUsers",params);
};
// 线索呼入时，提醒线索的跟进人
export const customCallInNotice = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/manage/callCenter/common/customCallInNotice",params);
};
// 线索呼入时，提醒线索的跟进人
export const makeCall = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/manage/callCenter/common/makeCall",params);
};


// 线索-获取已开启标签信息
export const getEnableClueTagConfig = (params) => {
  return get("/api/ding/customer/getEnableClueTagConfig",params);
};

// 线索-获取有效渠道
export const getEnableChannelSourceList = (params) => {
  return get("/api/ding/customer/getEnableChannelSourceList",params);
};

// 线索-批量转交
export const changeCustomOwner = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/ding/customer/changeCustomOwner",params);
};
// 线索-批量分配
export const batchAssignDing = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/ding/customer/batchAssignDing",params);
};

// 线索-线索释放还原收回
export const customWithdraw = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/ding/customer/customWithdraw",params);
};

// 线索-获取有效渠道
export const queryStoreInfo = (params) => {
  return get("/api/ding/customer/queryStoreInfoDing",params);
};

// 线索-跟进管理列表查询
export const queryFollowUpManageList = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/ding/customer/queryFollowUpManageListDing",params);
};

// 跟进-跟进提醒
export const queryFollowUpManageRemindDing   = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/ding/customer/queryFollowUpManageRemindDing  ",params);
};

// 跟进-取消跟进提醒
export const cancelFollowTaskDing   = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/ding/customer/cancelFollowTaskDing  ",params);
};

